<template>
  <v-main v-if="loading || error">
    <app-loading :visible="loading"></app-loading>
    <div v-if="error" class="text-center ma-5">
      Não foi possivel carregar o comprovante
    </div>
  </v-main>
  <div v-else class="document">
    <document-header :account="sender.name" description="Comprovante<br>de Transferência"></document-header>
    <div class="container">
      <div class="row row-wrap">
        <div class="col-6">
          <div class="item-box">
            <div class="item-box-header"><h4>Conta debitada</h4></div>
            <div class="item-box-content">
              <div class="row">
                <!-- <div class="col">
                  <h5>CPF/CNPJ</h5>
                  {{ sender.document | document }}
                </div> -->
                <div class="col">
                  <h5>Conta Heppi</h5>
                  {{ sender.heppiAccount }}
                </div>
              </div>
              <h5>Nome</h5>
              {{ sender.name }}
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="item-box">
            <div class="item-box-header"><h4>Favorecido</h4></div>
            <div class="item-box-content">
              <div class="row">
                <div v-if="!!mp" class="col">
                  <h5>CPF/CNPJ</h5>
                  {{ receiver.document | documentMasked }}
                </div>
                <div v-else class="col">
                  <h5>Conta Heppi</h5>
                  {{ receiver.heppiAccount }}
                </div>
              </div>
              <h5>Nome</h5>
              {{ receiver.name }}
            </div>
          </div>
        </div>
      </div>
      <div class="item-box mt-4">
        <div class="item-box-header"><h3>Detalhes do Pagamento</h3></div>
        <div class="item-box-content">
          <div class="row">
            <div class="col-auto pa-5">
              <div class="amount">
                {{ amount | priceInteger }}<small>,{{ amount | priceCents }}</small>
              </div>
            </div>
            <div class="col-auto pa-5 text-uppercase">
              <h5>Realizado em</h5>
              <div class="text-bold">
                {{ date | moment('DD MMM YYYY') }}
              </div>
            </div>
            <div class="col pa-5">
              <h5>Finalidade</h5>
              {{ description }}
            </div>
          </div>
        </div>
      </div>
      <div v-if="!!mp" class="item-box mt-4">
        <div class="item-box-header"><h3>Detalhes da Transação</h3></div>
        <div class="item-box-content">
          <div class="row">
            <div v-if="bank" class="col-6 px-5 pt-5 pb-1">
              <h5>Conta bancária</h5>
              {{ bank.name }}
              <br>
              Agência: {{ bank.agency }}
              <br>
              Conta {{ bank.type }}: {{ bank.account }}
            </div>
             <div v-if="pix" class="col-6 px-5 pt-5 pb-1">
              <h5>PIX</h5>
              {{ pix }}
            </div>
            <div class="col-6 px-5 pt-5 pb-1">
              <h5>Titular</h5>
              {{ titular || receiver.name }}
              <br>
              CPF/CNPJ: {{ document | documentMasked }}
            </div>
            <div class="col-6 px-5 pt-1 pb-5 text-uppercase">
              <h5>Realizado em</h5>
              <div class="text-bold">
                {{ date | moment('DD MMMM YYYY HH:mm') }}
              </div>
            </div>
            <div class="col-6 px-5 pt-1 pb-5">
              <h5>Código de autenticação</h5>
              {{ mp }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import axios from 'axios'
import AppLoading from '@/components/Loading'
import documentHeader from '@/components/documentHeader'
import { mapGetters } from 'vuex'

export default {
  name: 'transfer',
  components: {
    AppLoading,
    documentHeader
  },
  data () {
    return {
      loading: false,
      error: false,
      sender: {
        name: 'Medicina NASSAU 16',
        heppiAccount: '69692-5',
        document: '04854037490'
      },
      receiver: {
        name: 'LC SAVAGET ARQUITETURA LTDA',
        heppiAccount: '2210782-1',
        document: '48764730000195'
      },
      description: 'Pagamento Dennis DJ - 1/2 - 4',
      document: '48764730000195',
      titular: 'LC SAVAGET ARQUITETURA LTDA',
      amount: 6352,
      date: '2026-05-29 16:22',
      bank: {
        name: 'C6 Bank (366)',
        agency: '1',
        account: '338677577',
        type: 'Corrente'
      },
      mp: 'E90400888202605291922YN485526107'
    }
  },
  computed: {
    ...mapGetters(['transactionById']),
    transactionId () {
      return (this.$route.query && this.$route.query.id) || null
    },
    transactionData () {
      return this.transactionId ? this.transactionById(this.transactionId) : null
    }
  },
  async created () {
    if (!this.sender.name) {
      this.needSender = true
    } else {
      this.needSender = false
    }
    // if (this.transactionData) {
    //   this.loading = true
    //   try {
    //     // sender
    //     const senderId = this.transactionData.sender ? this.transactionData.sender.id : this.transactionData.account_id
    //     const sender = await axios.get('accounts/' + senderId + '?api_key=' + senderId, { baseURL: 'https://payment-gateway-api.heppi.io/api/' })
    //     if (sender.data) {
    //       this.sender = {
    //         name: sender.data.name,
    //         heppiAccount: sender.data.account_number,
    //         document: sender.data.owner.document
    //       }
    //     } else {
    //       this.error = true
    //     }
    //     // receiver
    //     const receiverId = this.transactionData.receiver ? this.transactionData.receiver.id : this.transactionData.account_id
    //     const receiver = await axios.get('accounts/' + receiverId + '?api_key=' + receiverId, { baseURL: 'https://payment-gateway-api.heppi.io/api/' })
    //     if (receiver.data) {
    //       this.receiver = {
    //         name: receiver.data.name,
    //         heppiAccount: receiver.data.account_number,
    //         document: receiver.data.owner.document
    //       }
    //     } else {
    //       this.error = true
    //     }
    //   } catch (error) {
    //     this.error = true
    //   }
    //   this.amount = this.transactionData.amount
    //   this.date = this.$moment(this.transactionData.payment_date.$date, 'YYYY-MM-DD[T]HH:mm[.000Z]').subtract(3, 'hours').format('YYYY-MM-DD HH:mm')
    //   this.description = this.transactionData.description
    //   this.loading = false
    // }
    document.title = this.sender.name + ' - ' + this.receiver.name + ' - transferencia - ' + this.$moment(this.date).format('DD-MM-YYYY')
  }
}
</script>
